import { render } from "./EntityList.vue?vue&type=template&id=b7314ab4&ts=true"
import script from "./EntityList.vue?vue&type=script&lang=ts"
export * from "./EntityList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__